import React from 'react';
import { Dialog } from '@tencent/spaui';
import { RPCFactory } from '../../utils/RequestUtil';

const width800 = {
  width: '800px',
};
const imgWidth = 798;
const pageNum = 2;

class GuideDialog extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      // 二次登录页面不展示
      show: window.location.hash == '#/secondLogin' ? false : props.show,
      currentIndex: 1,
      transform: {},
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      show: window.location.hash == '#/secondLogin' ? false : nextProps.show,
    });
  }

  handleNextTime = () => {
    this.setState({
      show: false,
    });
    RPCFactory.tips
      .nextTime(this.props.tipsCode)
      .done((data) => {})
      .fail((code, msg) => {
        alert(msg);
      });
  };

  handleSubmit = () => {
    this.setState({
      show: false,
    });
    RPCFactory.tips
      .noLonger(this.props.tipsCode)
      .done((data) => {})
      .fail((code, msg) => {
        alert(msg);
      });

    window.location.href = '#/system/leadsManageSetting';
  };

  handleClose = () => {
    this.setState({
      show: false,
    });
  };

  hasBefore = () => {
    if (this.state.currentIndex > 1) {
      return '';
    }
    return 'current';
  };

  hasNext = () => {
    if (this.state.currentIndex < pageNum) {
      return '';
    }
    return 'current';
  };

  setIndex = (index) => {
    this.setState({
      currentIndex: index,
      transform: {
        transform: `translateX(-${(index - 1) * imgWidth}px)`,
      },
    });
  };

  setBefore = () => {
    if (this.state.currentIndex > 1) {
      this.setIndex(this.state.currentIndex - 1);
    }
  };

  setNext = () => {
    if (this.state.currentIndex < pageNum) {
      this.setIndex(this.state.currentIndex + 1);
    }
  };

  ifCurrent = (index) => {
    if (this.state.currentIndex == index) {
      return 'current';
    }
    return '';
  };

  render() {
    const { show } = this.state;

    return (
      <div>
        <Dialog
          backdrop
          type="normal"
          className="spaui-dialog-confirm-normal modal-h5-guide-portal"
          title={'移动线索管理平台上线啦！'}
          show={show}
          onClose={this.handleClose}
          onSubmit={this.handleSubmit}
          onCancel={this.handleNextTime}
          style={width800}
          submitLabel="立即体验"
          cancelLabel="下次吧"
        >
          <div className="">
            <div className="show">
              <div className="imginfo">
                <div className="first" style={this.state.transform} />
                <div className="second" style={this.state.transform} />
              </div>
              <div
                className={`turn turn-l ${this.hasBefore()}`}
                onClick={(e) => {
                  this.setBefore();
                }}
              />
              <div
                className={`turn turn-r ${this.hasNext()}`}
                onClick={(e) => {
                  this.setNext();
                }}
              />
            </div>
            <div className="dotline">
              <span
                className={this.ifCurrent(1)}
                onClick={(e) => {
                  this.setIndex(1);
                }}
              />
              <span
                className={this.ifCurrent(2)}
                onClick={(e) => {
                  this.setIndex(2);
                }}
              />
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}
export default GuideDialog;
